import { useCallback, useState } from 'react';

export const useFetchImageSrc = (cb: Function, withUrl = false) => {
  const [status, setStatus] = useState<'loading' | 'failed' | 'succeeded'>(
    null
  );

  const fetchImage = useCallback(
    (src: string, fileName = '') => {
      if (!src) return;
      setStatus('loading');
      fetch(src)
        .then((res) => res.blob()) // convert the image to be a file
        .then((blob) => {
          // Create a File from the Blob
          const f = new File(
            [blob],
            fileName ? fileName + '.' + blob.type.split('/')[1] : undefined,
            { type: blob.type }
          );
          const url = URL.createObjectURL(blob);
          cb(f, withUrl ? url : undefined);
          setStatus('succeeded');
        })
        .catch((err) => {
          console.error('Failed to fetch image:', src, err);
          setStatus('failed');
        });
    },
    [cb, withUrl]
  );

  return { status, fetchImage };
};
